import AbstractComponentController from '../../../core/abstracts/controllers/component-controller';

export default class AlNavigationMainComponentController extends AbstractComponentController {

    constructor($scope, $injector, $element) {
        super($scope, $injector, $element);
        this.state = this.injector.get('$state');
        this.navHelper = this.injector.get('NavHelper');
        this.rootScope = this.injector.get('$rootScope');
        this.stateParams = this.injector.get('$stateParams');

        this._registerEventListeners();
    }

    $onInit() {
        this.navByKey = {};

        this.currentNavElement = null;
        this.rootNavInformation = [];
        this.pathInformation = [];
        this.eventSelectorNavElement = null;
        this.eventSelectorNavParentElement = null;

        this.navigationType = 'root';
        this.typeInformation = {};

        this.defaultNavEntry = {
            route: null,
            type: 'route',
            right: null,
            key: null
        };

        this._updateRootNavInformation();
        this._updatePathInformation();
        this._updateNavigationType();
        this.initializing = this.navHelper.isInitializing();
    }

    handleElementClick(navElement, extendedParameters) {
        this.navHelper.handleElementAction(navElement, extendedParameters);
    }

    _updateRootNavInformation() {
        this.rootNavInformation = this.navHelper.getRootNavInformation();
        this.scope.$applyAsync();
    }

    _registerEventListeners() {
        this.rootScope.$on('al-navigation-updated', () => {
            this._updateRootNavInformation();
            this._updatePathInformation();
            this._updateNavigationType();

            this.initializing = this.navHelper.isInitializing();
        })
    }

    _updateNavigationType() {
        if (
            !this.currentNavElement
            || this.currentNavElement.level < 2
        ) {
            this.navigationType = 'root';
            if (!this.currentNavElement) {
                return;
            }
        }

        if (this.currentNavElement.level >= 2) {
            this.navigationType = 'path';
        }

        let currentPathInformation = _.reverse(this.navHelper.getCurrentPathElements());
        if (!_.isUndefined(currentPathInformation[1]) && currentPathInformation[1].type === 'event-selector') {
            this.eventSelectorNavElement = currentPathInformation[1];
            this.eventSelectorNavParentElement = this.navHelper.getElementByKey(this.eventSelectorNavElement.parentKey);
            this.navigationType = 'event-selector';
            this.typeInformation = {
                guestlistId: this.stateParams[currentPathInformation[1].paramName]
            }
        }
    }

    _updatePathInformation() {
        this.currentNavElement = this.navHelper.getCurrentNavigationElement();

        const newPathInformation = this.navHelper.getCurrentPathElements();
        let eventSelectorInPath = false;

        _.each(newPathInformation, (navElement) => {
            let newDropdown = [];

            if (navElement.level === 1) {
                newDropdown = _.filter(this.navHelper.getRootNavInformation(), (navElement) => {
                    return navElement.showInNavigation && (!_.isFunction(navElement.customAccessor) || navElement.customAccessor(this.injector));
                });
            } else if (navElement.type !== 'event-selector') {
                newDropdown = _.filter(this.navHelper.getChildrenByParentKey(navElement.parentKey), (navElement) => {
                    return navElement.showInNavigation && (!_.isFunction(navElement.customAccessor) || navElement.customAccessor(this.injector));
                });
            } else if (navElement.type === 'event-selector') {
                newDropdown = navElement.events;
                eventSelectorInPath = true;
            }

            navElement.dropdown = newDropdown;
        });

        this.pathInformation = _.filter(newPathInformation, (navElement) => {
            return this.currentNavElement.level !== navElement.level;
        });

        if (eventSelectorInPath && this.pathInformation.length > 1) {
            // this.pathInformation.splice(0, 1);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/navigation/components/al-navigation-main/controller.js